import * as React from "react";
import {BooleanRadioButton, BooleanRadioButtonGroup} from "@octopusdeploy/design-system-components";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import {Text} from "components/form";
import { Callout } from "@octopusdeploy/design-system-components";
import repository from "client/repository";
import {CloneReefRequest} from "client/resources/cloneReefRequest";
import {ReefResource} from "client/resources/reefResource";

interface Props {
    reef: ReefResource;
    onSaved: (newReefId: string) => void;
}

interface State extends DataBaseComponentState {
    cloneReefRequest: Partial<CloneReefRequest>;
}

class CloneReefDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            cloneReefRequest: {ProvisionResources: false},
        };
    }

    render() {
        return <SaveDialogLayout title={"Clone"}
                                 busy={this.state.busy}
                                 errors={this.state.errors}
                                 onSaveClick={() => this.cloneReef()}>

            <Callout type="warning" title="!!! Do not use in Production !!!">
                Use cloning only during <strong>testing</strong> where reefs don't have to be fully isolated
                and it is ok for them to share secrets.
            </Callout>

            <Text label="Name"
                  hintText="This name will be used as the name of all major resources"
                  value={this.state.cloneReefRequest.Name}
                  onChange={Name => this.updateCloneReefRequest({Name})}
                  autoFocus={true}
            />

            <Text label="VNet Address Space"
                  hintText="CIDR notation, with a /17 prefix length"
                  value={this.state.cloneReefRequest.AddressSpace}
                  onChange={AddressSpace => this.updateCloneReefRequest({AddressSpace})}
            />

            <BooleanRadioButtonGroup value={this.state.cloneReefRequest.ProvisionResources} onChange={ProvisionResources => this.updateCloneReefRequest({ProvisionResources})}>
                <BooleanRadioButton value={true} label="Provision Resources" />
                <BooleanRadioButton value={false} label="Adopt Existing Resources" />
            </BooleanRadioButtonGroup>

        </SaveDialogLayout>;
    }

    private updateCloneReefRequest(update: Partial<CloneReefRequest>) {
        this.setState(prevState => ({cloneReefRequest: {...prevState.cloneReefRequest, ...update}}));
    }

    private cloneReef = (): Promise<boolean> => {
        return this.doBusyTask(async () => {
            const clone = await repository.Reefs.clone(this.props.reef, this.state.cloneReefRequest as CloneReefRequest);
            this.props.onSaved(clone.Id);

            return true;
        });
    };
}

export default CloneReefDialog;
